/**
 * 错误上报
 */

let link = "https://error-fe.scnleee.com/api/errrorlog/receive";
const REPORT_OPT = {
	id: 120, //错误上报的id
	url: link, //上报url
	random: 1, //抽样上报
	offlineLog: false, //是否离线上报
	submit: function (url) {
		var query1 = BJ_REPORT.urlSearchParse(url.split("?")[1]);
		var query2 = BJ_REPORT.urlQueryParse(query1);
		BJ_REPORT.request.ajax({
			url: link,
			type: "POST",
			data: query2,
			success: function (e) {
				console.log(e);
			},
			error: function (e) {
				console.log(e);
			},
		});
	},
	onReport: function (id, errObj) {
		//上报回调
		console.log(id, errObj);
	},
};

/**
 * 初始化上报sdk
 */
export const badjsInit = function () {
	let timer = null;
	let initQueue = () => {
		clearTimeout(timer);
		if (window.BJ_REPORT) {
			let opt = Object.assign({}, REPORT_OPT);
			try {
				BJ_REPORT.init(opt);
			} catch (error) {}
		} else {
			timer = setTimeout(initQueue, 1000);
		}
	};
	initQueue();
};

/**
 *
 * @param {*} options
 * 单独上报的时候使用
 *
 */
export const badjsReport = (
	options = {
		msg: {}, //错误信息
		target: "unknow", //错误目标接口或文件或组件
		from: "", //来源链接
		rowNum: "0", //error出现的行号
		colNum: "0", //error出现的列号
	}
) => {
	// 如果没有提供from参数且在客户端环境，则使用当前页面URL
	if (!options.from && typeof window !== 'undefined' && typeof location !== 'undefined') {
		options.from = location.href;
	}
	if ("object" === typeof options.msg) {
		options.msg = JSON.stringify(options.msg);
	}
	window.BJ_REPORT && BJ_REPORT.report(options);
};
